import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { capitalizeAndRemoveUnderscores, limitWords, downloadFile } from "../../utils/utils";
import { Descriptions, Input, InputNumber, Button, message, DatePicker, Form, Modal, Upload, Table, Tabs, Tooltip, Select, FloatButton, Popover, Spin, AutoComplete, Result, Tag, } from "antd";
import dayjs from "dayjs";
import { EditOutlined, ArrowLeftOutlined, ExportOutlined, MailOutlined, DownloadOutlined, MoreOutlined, HighlightOutlined, IdcardOutlined, UploadOutlined, PictureOutlined, FileTextOutlined, SendOutlined } from '@ant-design/icons';
import customParseFormat from "dayjs/plugin/customParseFormat";
import ButtonComp from "../../components/button/ButtonComp";
import { formatIndianDate } from "../../utils/Constant";
import MasterTemplateModal from "../masterTemplate/MasterTempModal";
import ClausesModal from "../clauseTemplate/clauseTemplateModal";
import { parseDuration } from '../../utils/utils'
import { useLocation } from 'react-router-dom';
import EditProductsTab from "./Tabs/editProductsTab";
import SentAgreementModel from "./model/sentAgreementModel";
import Chat from "./Chat/Chat";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import EmailSystem from "./EmailComponent/Email.jsx";
import CustomTab from "./CustomTab/CustomTab.jsx";
import FileButton from "../../components/button/FileButton.jsx";
import PreviewModal from "../../components/modal/PreviewModal.jsx";
import { useTheme } from "../../utils/themeToggle/theme.jsx";
import ApprovalMatrixTimeline2 from "./ApprvalMatrixTab/ApprovalMatrixTimeline2.jsx";
import BussinessDetailsComponent from "../../components/Contract/BussinessDetailsComponent.jsx";
import VersionControl from "./VersionControl/VersionControl.jsx";
import FutureDateWarningModal from "../../components/modal/FutureDateWarningModal.jsx";
import LinkedAgreementsModal from "../../components/modal/LinkedAgreementsModal.jsx";
import SendContractModal from "../../components/modal/SendContractModal.jsx";
import CounterPartyModal from "../../components/modal/CounterPartyModal.jsx";
import ConfirmModifyModal from "../../components/modal/ConfirmModifyModal.jsx";
import AssignDiffUserModal from "../../components/modal/AssignDiffUserModal.jsx";

dayjs.extend(customParseFormat);
// const dateFormat = "DD-MM-YYYY";
const { TabPane } = Tabs;
const { TextArea } = Input;

function ContractDetailComp() {
  const [years, setYears] = useState();
  const [months, setMonths] = useState();
  const [days, setDays] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const [contract, setContract] = useState();
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMasterLoading, setIsMasterLoading] = useState(false);
  const [isClauseLoading, setIsClauseLoading] = useState(false);
  const [clausesData, setClausesData] = useState([]);
  const [masterClausesData, setMasterClausesData] = useState([]);
  const [countries, setCountries] = useState();
  const [clientStates, setClientStates] = useState([]);
  const [partyStates, setPartyStates] = useState();
  const [fileUploading, setFileUploading] = useState(false);
  const [masterTempUploading, setMasterTempUploading] = useState(false);
  const [editedContract, setEditedContract] = useState({});
  const [isSendModalVisible, setIsSendModalVisible] = useState(false);
  const [isThirdPartyVisible, setIsThirdPartyVisible] = useState(false);
  const [isDifferentUser, setIsDifferentUser] = useState(false);
  const [masterTempModal, setMasterTempModal] = useState(false);
  const [clauseTempModal, setClauseTempModal] = useState(false);
  const [companyDiffUsers, setCompanyDiffUsers] = useState([]);
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [isOpnSentAgreement, setIsOpnSentAgreement] = useState(false);
  const [agreementFileBeforeEsign, setAgreementFileBeforeEsign] = useState("")
  const [selectedStatus, setSelectedStatus] = useState();
  const [productEditMode, setProductEditMode] = useState(false);
  const [finalPage, setFinalPage] = useState(6);
  const [effectiveDate, setEffectiveDate] = useState(
    contract && contract.effective_date
  );
  const [executionDate, setExecutionDate] = useState(
    contract && contract.date_of_execution
  );
  const [dateModalVisible, setDateModalVisible] = useState(false);
  const [signuluResponse, setSignuluResponse] = useState({});
  const queryParams = new URLSearchParams(window.location.search);
  const referrer = queryParams.get("referrer");
  const [esignDetailModalOpen, setEsignDetailModalOpen] = useState(false);
  const [isModifyOpen, setModifyOpen] = useState(false);
  const [isReminderLoading, setIsReminderLoading] = useState(false);
  const [pendingEmails, setPendingEmails] = useState([]);
  const [documentId, setDocumentId] = useState([]);
  const [errorMessageShown, setErrorMessageShown] = useState(false);
  const [SendContractForm] = Form.useForm();
  const [CounterPartyForm] = Form.useForm();
  const [differentUserForm] = Form.useForm();
  const [customFieldsForm] = Form.useForm();
  const [addUserForm] = Form.useForm();
  const [addAttachmentsForm] = Form.useForm();
  const location = useLocation();
  const warMdlType = useRef(null);
  const warMdlBod = useRef('');
  const uploadRef = useRef(null)
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "1"
  const [activeTab, setActiveTab] = useState(initialTab);
  const tab = searchParams.get("tab");
  const select = useSelector((state) => state.auth.userInfo);
  const user_role = select.role;
  const user_email = select.user_email;
  const user_id = select.user_id;
  const [isLinkedModalVisible, setIsLinkedModalVisible] = useState(false);
  const [errorinContractGet, setErrorinContractGet] = useState(null);
  const [isComparing, setIsComparing] = useState(false);
  const { Option } = Select;
  const [compareMode, setCompareMode] = useState(false);
  const [selectedPrev, setSelectedPrev] = useState(null);
  const [selectedCurr, setSelectedCurr] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const compnayId = localStorage.getItem("companyId") || comp_id;
  const fromNotification = location.search.includes('from=notification')
  let canShowErrorMessage = true;
  // let updatedCustomForm = useMemo(() => contract ? { ...contract.custom_field } : {}, [contract?.custom_field])
  const dropdownStyle = {
    width: "auto",
    minWidth: "150px",
    maxWidth: "300px",
  };
  const pathname =
    referrer === "dashboard"
      ? "/admin/dashboard"
      : referrer === "audit-trail"
        ? "/admin/dashboard/audit-trail"
        : "/admin/contracts";

  const userRole = user_role;
  const role = userRole && userRole.toLowerCase();
  const { darkMode } = useTheme()
  let statusOptions = [];
  if (contract) {
    statusOptions = [
      ...(contract.is_draft ? [{ value: "FRESH_REQUEST", label: "Fresh Request" }] : []),
      { value: "UNDER_NEGOTIATION", label: "Under Negotiation" },
      { value: "UNDER_EXECUTION", label: "Under Execution" },
      ...(role && (role.toLowerCase() === "agreement controller team" || role.toLowerCase() === "professional agreement controller team" || role.toLowerCase() === "professional agreement controller head" || role.toLowerCase() === "agreement controller head" || role.toLowerCase() === "professional")
        ? [{ value: "EXECUTED", label: "Executed" }]
        : []),
      ...(user_email === contract.created_by
        ? [{ value: "TRANSACTION_CLOSED", label: "Transaction Closed" }]
        : []),
    ];
  }
  if (role.toLowerCase() === "businessteam") {
    statusOptions = statusOptions.filter(
      (option) => option.value !== "EXECUTED"
    );
  }

  const dataCopy = { ...editedContract };
  delete dataCopy.company;
  delete dataCopy.agreement;
  delete dataCopy.contract_access_users;
  delete dataCopy.created_by;
  delete dataCopy.created_at;
  delete dataCopy.date_of_execution;
  delete dataCopy.expiry_date;
  delete dataCopy.id;
  delete dataCopy.modified_at;
  delete dataCopy.party_name;
  delete dataCopy.term_sheet;
  delete dataCopy.user_name;
  const countryId =
    dataCopy &&
    dataCopy.party_address &&
    dataCopy.party_address.country &&
    dataCopy.party_address.country.id;
  const stateId =
    dataCopy &&
    dataCopy.party_address &&
    dataCopy.party_address.state &&
    dataCopy.party_address.state.id;
  const clientCountryId =
    dataCopy &&
    dataCopy.client_address &&
    dataCopy.client_address.country &&
    dataCopy.client_address.country.id;

  const clientStateId =
    dataCopy &&
    dataCopy.client_address &&
    dataCopy.client_address.state &&
    dataCopy.client_address.state.id;

  const newData = {
    ...dataCopy,
    party_address: {
      ...dataCopy.party_address,
      country: countryId,
      state: stateId,
    },

    client_address: {
      ...(dataCopy.client_address || {}),
      ...(clientCountryId && { country: clientCountryId }),
      ...(clientStateId && { state: clientStateId }),
      ...(dataCopy.client_address?.address1 && {
        address1: dataCopy.client_address.address1,
      }),
      ...(dataCopy.client_address?.address2 && {
        address2: dataCopy.client_address.address2,
      }),
      ...(dataCopy.client_address?.city && {
        city: dataCopy.client_address.city,
      }),
      ...(dataCopy.client_address?.postal_code && {
        postal_code: dataCopy.client_address.postal_code,
      }),
    },
    effective_date: effectiveDate && effectiveDate,
    date_of_execution: executionDate && executionDate,
    payment_due_date: contract && contract.payment_due_date,
  };

  const esignColumns = [
    {
      title: "Signed By",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => (
        <>
          <Tooltip title={text}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {limitWords(text, 100)}
            </div>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Signature Image",
      dataIndex: "signatureImage",
      ellipsis: true, // Enable ellipsis for the column
      render: (text) => <img src={text} alt="sign" className="h-20" />,
    },
    {
      title: "Signature Status",
      dataIndex: "status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
  ];
  // let shownReminders = true;
  let shouldShowGlobalReminder = true;

  const handleChangeView = async (prev, curr) => {
    try {
      // setHasBeenShown(true);
      if (!prev || !curr) {
        message.error("Both previous and current file must be selected.");
        return;
      }
      const res = await axiosInstance.post(`contract/Compare/`, {
        original_url: prev?.url,
        revised_url: curr?.url,
      });

      console.log("handleChangeView Response:", res.data);

      const diffSFDT = res?.data?.sfdt;
      if (diffSFDT) {
        localStorage.setItem('diff_sfdt', JSON.stringify(diffSFDT));
        window.open('/version-diff-viewer', '_blank');
      } else {
        message.warning("No differences found.");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to fetch the differences.";
      message.error(errorMsg);
      console.error("handleChangeView Error:", error);
    } finally {
      // setHasBeenShown(false);
    }
  };

  const handleTrackChangeView = async (diffUrl) => {
    try {
      if (diffUrl) {
        const encodedUrl = encodeURIComponent(diffUrl);
        window.open(`/version-diff-viewer?file=${encodedUrl}`, "_blank");
      } else {
        message.warning("No differences found.");
      }
    } catch (error) {
      message.error(error.message || "Failed to fetch the differences.");
    } finally {
      // setHasBeenShown(false);
    }
  };


  const columns = [
    {
      title: "Initiator",
      dataIndex: "modification_user_name",
    },
    {
      title: "Contributor",
      dataIndex: "contributor_name",
      ellipsis: true,
      render: (text, record, index) => {
        const thirdPartyId = record?.third_party;
        const isNotSent = record?.is_sent_to_third_party === false;
        const isSent = record?.is_sent_to_third_party === true;
        if (isSent) {
          shouldShowGlobalReminder = false;
        }
        // const showReminder = thirdPartyId && isNotSent && shownReminders && shouldShowGlobalReminder;
        // if (showReminder) {
        //   shownReminders = false;
        // }
        return (
          <Tooltip title={text?.toString()}>
            <div
            >
              {limitWords(text?.toString())}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Current Status",
      dataIndex: "current_status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: "Previous Status",
      dataIndex: "previous_status",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: (
        <div>
          Modified On Date <br />
        </div>
      ),
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => formatIndianDate(date),
    },
    {
      title: "Current Version",
      dataIndex: "agreement",
      render: (text, record) => (
        <FileButton
          fileUrl={record.current_agreement}
          isSelected={selectedCurr?.rowId === record.key}
          compareMode={compareMode}
          type="Current"
          onSelect={(url) => {
            setSelectedCurr((prev) =>
              prev?.rowId === record.key ? null : { rowId: record.key, url }
            );
          }}
          onPreview={(url) => setPreviewFile(url) || setIsModalOpen(true)}
        />
      ),
    },
    {
      title: "Previous Version",
      dataIndex: "agreement",
      render: (text, record) => (
        <FileButton
          fileUrl={record.previous_agreement}
          isSelected={selectedPrev?.rowId === record.key}
          compareMode={compareMode}
          type="Previous"
          onSelect={(url) => {
            setSelectedPrev((prev) =>
              prev?.rowId === record.key ? null : { rowId: record.key, url }
            );
          }}
          onPreview={(url) => setPreviewFile(url) || setIsModalOpen(true)}
        />
      ),
    },

    // {
    //   title: "Unauthorized Changes",
    //   key: "unauthorized_changes",
    //   render: (text, record) => {
    //     const isDisabled = !record?.compare_file_url;

    //     return (
    //       <Tooltip title={isDisabled ? "No diff available" : "View unauthorized changes"}>
    //         <Button
    //           onClick={() => {
    //             if (!isDisabled) handleTrackChangeView(record.compare_file_url);
    //           }}
    //           disabled={isDisabled}
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "center",
    //             width: "100%",
    //             opacity: isDisabled ? 0.2 : 1,
    //             cursor: isDisabled ? "not-allowed" : "pointer",
    //             border: "none", // ⬅️ No border,
    //             boxShadow: "none" // optional glow
    //           }}
    //         >
    //           <EyeOutlineIcon />
    //         </Button>
    //       </Tooltip>
    //     );
    //   },
    // }


  ];


  let customFieldsValue = [];
  if (contract && contract.custom_field) {
    customFieldsValue = Object.keys(contract.custom_field)
      .filter((key) => key.includes("field"))
      .map((key) => ({
        field: key.includes("field") ? contract.custom_field[key] : "",
      }));
  }

  let customValues = [];
  if (contract && contract.custom_field) {
    customValues = Object.keys(contract.custom_field)
      .filter((key) => key.includes("value"))
      .map((key) => ({
        value: key.includes("value") ? contract.custom_field[key] : "",
      }));
  }

  const combinedCustomList = customFieldsValue.map((fieldObj, index) => ({
    field: fieldObj.field,
    value: customValues[index]?.value,
  }));

  let contractUsersOption = [];
  const setTenureDate = (values) => `${values[0]} Years ${values[1]} Months ${values[2]} Days`;

  const handleOpenLinkedModal = () => {
    setIsLinkedModalVisible(true);
  };


  const handleSendReminder = async () => {
    console.log(pendingEmails)
    if (!pendingEmails || pendingEmails.length === 0) {
      message.warning("All recipients have already approved. No reminders sent");
      return;
    }

    setIsReminderLoading(true);

    try {
      const res = await axiosInstance.post("/send-esign-reminder/", {
        emails: pendingEmails,
        document_id: documentId,
        company_id: compnayId,
      });
      message.success("Reminder sent successfully!");
    } catch (err) {
      console.error("Reminder error:", err);
      message.error("Failed to send reminder.");
    } finally {
      setIsReminderLoading(false);
    }
  };

  const handleOk = (type) => {
    if (type === 'Send Contract') {
      SendContractForm.submit();
    } else if (type === 'Counter Party') {
      CounterPartyForm.submit();
    } else if (type === 'Contract to Different User') {
      differentUserForm.submit();
    } else if (type === 'Add Custom Fields') {
      customFieldsForm.submit();
    } else if (type === 'Add User') {
      addUserForm.submit();
    } else if (type === 'Add Attachments') {
      addAttachmentsForm.submit();
    }
  };

  const handleModalCancel = () => {
    setIsSendModalVisible(false);
    setIsThirdPartyVisible(false);
    setIsDifferentUser(false);
    setMasterTempModal(false);
    SendContractForm.resetFields();
    CounterPartyForm.resetFields();
    differentUserForm.resetFields();
    customFieldsForm.resetFields();
    addUserForm.resetFields();
    addAttachmentsForm.resetFields();
  };

  const selectedStatusOption = (value) => {
    setSelectedStatus(value);
  };
  const handleEdit = () => {
    setEditMode(true);
  };
  const fetchState = async (value, type) => {
    try {
      const response = await axiosInstance.get("/state/get/", {
        customParams: {
          country_id: value,
        },
      });
      if (type === "all") {
      } else if (type === "client") {
        setClientStates(response.data);
      } else if (type === "party") {
        setPartyStates(response.data);
      }
    } catch (error) { }
  };
  const handleCancel = () => {
    // updatedCustomForm = contract ? { ...contract.custom_field } : {};
    setEditMode(false);
    setProductEditMode(false);
  };
  const handleSave = (data) => {
    if (data?.custom_field) {
      const hasEmptyValues = Object.values(data.custom_field)?.some(value => !value.trim());
      if (hasEmptyValues) {
        message.error('Every field should be fill up in custom tab')
        return false;
      }
    }
    const tenure = setTenureDate([years, months, days]);
    const payload = data ? { ...data, tenure } : { ...newData, tenure };
    axiosInstance.patch(`/contract/${params.pk}/update/`, { data: payload })
      .then((response) => {
        setEditMode(false);
        setProductEditMode(false);
        customFieldsForm.resetFields();
        message.success("Contract Updated Successfully");
        fetchContracts();
      })
      .catch((error) => {
        console.error("Error updating contract:", error.response?.data || error.message);
        setProductEditMode(false);
        setEditMode(false);

        // Show error message
        message.error("An error occurred while updating the contract.");
      })
      .finally(() => {
        console.log("handleSave API call completed.");
      });
  };

  const handleAddressChange = (e, addressType, select, type, multiData) => {
    const { name, value } = e.target;
    if (name === "country") {
      if (addressType === "client_address") {
        fetchState(value, "client");
      } else if (addressType === "party_address") {
        fetchState(value, "party");
      }
    }

    setEditedContract((prevAddress) => {
      if (!prevAddress) {
        return {
          [addressType]:
            select === "select" ? multiData ? multiData : { [type]: { id: value } } : { [name]: value },
        };
      }

      let updatedAddressType = prevAddress[addressType]
        ? { ...prevAddress[addressType] }
        : {};

      if (select === "select") {
        if (multiData) {
          updatedAddressType = { ...prevAddress[addressType], ...multiData };
        } else {
          updatedAddressType[type] =
            prevAddress[addressType] && prevAddress[addressType][type]
              ? { ...prevAddress[addressType][type], id: value }
              : { id: value };
        }

      } else {
        updatedAddressType[name] = value;
      }
      return {
        ...prevAddress,
        [addressType]: updatedAddressType,
      };
    });
  };
  const handleAgreementChange = (value, key) => {
    console.log({ value, key })
    setEditedContract((prevCompany) => ({
      ...prevCompany,
      [key]: value,
    }));
  };

  const fetchContracts = async () => {
    try {
      const response = await axiosInstance.post(`/contract/${params.pk}/get/`, { id: params.pk, company_id: localStorage.getItem("companyId") || comp_id });
      const getDataValue = parseDuration(response.data.tenure);
      setYears(getDataValue[1])
      setMonths(getDataValue[2])
      setDays(getDataValue[3])
      setContract(response.data);
      setEditedContract(response.data);
      setDocumentId(response.data.document_id)
    } catch (error) {
      setErrorinContractGet(error.response?.data?.error || "Failed to fetch contract details");
      console.log(error.response?.data?.error, "error in fetchContracts")
    }
  };
  const onVersionControlDownload = async (link) => {
    try {
      if (!link) {
        message.error('There is no file to download');
        return false;
      }
      console.log(link)
      await downloadFile(link, contract?.document_id)
    } catch (error) {
      console.log(error)
    }
  }
  const onEllipseDownload = async (link, name) => {
    const payload = {
      agreement_id: params.pk
    }
    try {
      if (!link) {
        message.error('Document dose not exits .');
        return;
      }
      await downloadFile(link, name, true);
      message.success('Download completed .')
    } catch (error) {
      console.log(error)
      message.error(error?.response?.data?.error)
    }
  }
  const handlePdfDownload = (agreeementPdf) => {
    if (agreeementPdf) {
      downloadFile(agreeementPdf, contract?.document_id)
      setErrorMessageShown(false);
    } else {
      if (!errorMessageShown) {
        message.error("Document does not exist.");
        setErrorMessageShown(true);
        setTimeout(() => {
          setErrorMessageShown(false);
        }, 5000);
      }
    }
  };
  const customRequest = ({ file, onSuccess, onError }) => {
    setFileUploading(true);
    // Custom logic to handle file upload
    const formData = new FormData();
    formData.append("agreement_file", file);
    formData.append("agreement_id", contract && contract.id);
    formData.append("company_id", compnayId);

    try {
      axiosInstance.post(`/contract/save_agreement_file/`, formData)
        .then((response) => {
          onSuccess(); // Trigger success callback
          message.success("Document Saved Successfully.");
          fetchContracts();
          setFileUploading(false);
        })
        .catch((error) => {
          onError(); // Trigger error callback
          message.error(error?.response?.data?.error.error);
          setFileUploading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const uploadFile = async ({ id, clause }) => {
    setMasterTempUploading(true);
    const formData = new FormData();
    formData.append("agreement_id", contract && contract.id);
    formData.append("company_id", compnayId);

    if (id) {
      formData.append("master_template_id", id);
    }
    if (clause) {
      formData.append("clause_list", JSON.stringify(clause));
    }

    const loadingKey = "fileUploadInProgress";

    try {
      // Show loading message indefinitely
      if (id || clause) {
        message.loading({
          content: "Uploading file...",
          key: loadingKey,
          duration: 0, // stays forever until manually destroyed
        });
      }

      if (id) setIsMasterLoading(true);
      if (clause) setIsClauseLoading(true);

      const response = await axiosInstance.post(`/contract/save_agreement_file/`, formData);

      if (response.status === 200) {
        message.success({
          content: "Document Saved Successfully.",
          key: loadingKey, // this replaces the loading message
          duration: 2, // visible for 2 seconds
        });
      } else {
        message.error({
          content: "Something went wrong.",
          key: loadingKey,
          duration: 2,
        });
      }

      return { data: response.data, res: response };
    } catch (error) {
      console.log(error);
      message.error({
        content: "Upload failed. Please try again.",
        key: loadingKey,
        duration: 3, // error dikhe 3 sec tak
      });
    } finally {
      setMasterTempUploading(false);
      setIsMasterLoading(false);
      setIsClauseLoading(false);
      setMasterTempModal(false);
      setClauseTempModal(false);
    }
  };

  const uploadMasterTemp = ({ id }) => {
    uploadFile({ id });
  };
  const handleClauseSubmit = (clause) => {
    uploadFile({ clause: clause });
  };

  const fetchMasterTemplates = async () => {
    try {
      const response = await axiosInstance.get(`/contract/get-master-template/`)
      setMasterTemplateData(response.data);
    } catch (error) { }
  };
  const handleMasterTempButton = () => {
    setMasterTempModal(true);
  };
  const handleClauseTempButton = () => {
    setClauseTempModal(true);
  };
  const handleMasterTempCancelButton = () => {
    setMasterTempModal(false);
  };
  const handleClauseTempCancelButton = () => {
    setClauseTempModal(false);
  };
  const isEsignPenCom = (type, bod) => {
    warMdlType.current = type;
    warMdlBod.current = bod[contract.esign_status];
    return warMdlBod.current
  }
  const handleUploadClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const param = {
      'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
      'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
    }
    const isEsignStatus = isEsignPenCom('uploadFromLocal', param)
    if (isEsignStatus) {
      setModifyOpen(isEsignStatus);

      return isEsignStatus;
    }

    if (uploadRef.current && uploadRef.current.upload && uploadRef.current.upload.uploader) {
      uploadRef.current.upload.uploader.onClick();
    }

  };
  const uploadContent = (
    <div>
      <div className="flex justify-center">
        <Upload
          customRequest={customRequest}
          showUploadList={false} // Hide the default file list
          ref={uploadRef}
        // openFileDialogOnClick={ false }
        >
          <Button
            icon={<UploadOutlined />}
            loading={fileUploading}
            className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
            onClick={handleUploadClick}
          >
            {fileUploading ? "Uploading" : "Upload from device"}
          </Button>
        </Upload>
      </div>
      <div>
        <Button
          icon={<UploadOutlined />}
          loading={isMasterLoading}
          className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
          onClick={() => {
            const param = {
              'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
              'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
            }
            const isEsignStatus = isEsignPenCom('uploadFromMstTem', param)
            if (isEsignStatus) {
              setModifyOpen(isEsignStatus);

              return isEsignStatus;
            } // Open confirmation modal
            handleMasterTempButton()

          }}
        >
          {"Master Template"}
        </Button>
      </div>
      <div>
        <Button
          icon={<PictureOutlined />}
          loading={isClauseLoading}
          className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
          onClick={() => {
            const param = {
              'pending': 'The Agreement has been forwarded for e-signature. Would you like to continue?',
              'completed': 'The Agreement has been signed by all the Parties. Would you like to continue?'
            }
            const isEsignStatus = isEsignPenCom('uploadFromClause', param)
            if (isEsignStatus) {
              setModifyOpen(isEsignStatus);

              return isEsignStatus;
            } // Open confirmation modal
            handleClauseTempButton();

          }}
        >
          {"Clause"}
        </Button>
      </div>
    </div>
  );
  const openInNewTab = (params, agreementFile, agreementFileBeforeEsign) => {
    const getExtension = (url) => {
      return url?.split('.').pop()?.toLowerCase();
    };

    const agreementExt = getExtension(agreementFile);
    let fileToOpen = null;

    if (agreementExt === 'pdf') {
      fileToOpen = agreementFileBeforeEsign || agreementFile;
    } else {
      fileToOpen = agreementFile;
    }

    if (!params || !fileToOpen) {
      if (!errorMessageShown) {
        message.error("Document does not exist.");
        setErrorMessageShown(true);
        setTimeout(() => {
          setErrorMessageShown(false);
        }, 5000);
      }
    } else {
      onOpenEditor(fileToOpen);
    }
  };
  const onOpenEditor = async (link) => {
    try {
      const fileToOpen = link;
      const encodedFile = encodeURIComponent(fileToOpen);
      const timestamp = Date.now();
      window.open(`/edit-document/${params?.pk}?agreementFile=${encodedFile}&t=${timestamp}&editable=true`, "_blank");
    } catch (error) {
      console.log(error)
    }
  }
  const handleSendButton = () => {
    setIsSendModalVisible(true);
  };
  const handleThirdPartyButton = () => {
    setIsThirdPartyVisible(true);
  };
  const handleDiffUserButton = () => {
    setIsDifferentUser(true);
  };
  const validateBeforeExecution = (contractData) => {
    const missingFields = [];
    console.log(contractData, "contractData")
    const {
      name_of_authorised_signatory_of_party,
      name_of_authorised_signatory_of_client,
      party_address,
      nature,
      agreement_type,
      effective_date,
      client_address,
      date_of_execution,
      jurisdiction,
      termination_notice,
      agreement_file,
      remarks,
    } = contractData;

    if (!effective_date) missingFields.push("Effective Date");
    if (!date_of_execution) missingFields.push("Execution Date");
    if (!jurisdiction) missingFields.push("Jurisdiction of Agreement");
    if (!termination_notice) missingFields.push("termination Notice in Agreement Detail");
    if (!nature) missingFields.push("Nature of Agreement");
    if (!agreement_type) missingFields.push("Type of Agreement");
    if (!party_address?.state?.id) missingFields.push("Business Entity State");
    if (!party_address?.country?.id) missingFields.push("Business Entity Country");
    if (!party_address.postal_code) missingFields.push("Business Entity Postal Code");
    if (!party_address.city) missingFields.push("Business Entity City");
    if (!party_address.address2) missingFields.push("Business Entity Address - Line 2");
    if (!party_address.address1) missingFields.push("Business Entity Address - Line 1");
    if (!name_of_authorised_signatory_of_client) missingFields.push("Authorized Signatory Name of Business Entity");
    if (!client_address?.state?.id) missingFields.push("Business Partner State");
    if (!client_address?.country?.id) missingFields.push("Business Partner Country");
    if (!client_address.postal_code) missingFields.push("Business Partner Postal Code");
    if (!client_address.city) missingFields.push("Business Partner City");
    if (!client_address.address2) missingFields.push("Business Partner Address - Line 2");
    if (!client_address.address1) missingFields.push("Business Partner Address - Line 1");
    if (!name_of_authorised_signatory_of_party) missingFields.push("Authorized Signatory Name of Business Partner");
    if (!agreement_file) missingFields.push("Agreement File");

    return missingFields;
  };
  const handleSendSubmit = (values) => {
    if (values.status === "EXECUTED") {
      const missingFields = validateBeforeExecution(editedContract);
      if (missingFields.length > 0) {
        setIsSendModalVisible(false);
        missingFields.forEach((field) => message.error(`${field} is required`));
        return;
      }
    }

    const updatedValues = {
      ...values,
      agreement_id: contract && contract?.id,
    };

    // setSending(true);

    // Show loading message
    const hideLoading = message.loading("Sending contract...", 0); // 0 => stays until manually destroyed

    axiosInstance
      .post(`/contract/send_agreement/`, updatedValues)
      .then((response) => {
        hideLoading(); // remove loading
        message.success(response.data.message || "Contract sent successfully!");
        setIsSendModalVisible(false);
        SendContractForm.resetFields();
        navigate("/admin/contracts/");
      })
      .catch((error) => {
        hideLoading(); // remove loading
        message.error(
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          "Failed To Send"
        );
        setIsSendModalVisible(false);
        SendContractForm.resetFields();
      })
      .finally(() => {
        // setSending(false);
      });
  };

  const assignDiffUser = (values) => {
    const updatedValues = {
      ...values,
      agreement_id: contract && contract.id,
      company_id: compnayId,
    };
    axiosInstance.put(`/contract/assign-agreement-to-diff-user/`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsDifferentUser(false);
        navigate(-1)        // backend team wants to redirect to pri page after successfull 
        differentUserForm.resetFields();
      })
      .catch((error) => {
        message.error("Some Error Occured.");
        setIsDifferentUser(false);
        differentUserForm.resetFields();
      });
  };
  const handleThirdPartySubmit = (values) => {
    const updatedValues = {
      ...values,
      agreement_id: contract && contract.id,
      company_id: localStorage.getItem("companyId") || comp_id

    };

    axiosInstance.post(`/contract/send-agreement-to-self`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsThirdPartyVisible(false);
        fetchContracts();
        CounterPartyForm.resetFields();
        navigate("/admin/contracts/");
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setIsSendModalVisible(false);
        CounterPartyForm.resetFields();
      });
  };
  const handleSubmitSendToSelf = () => {
    const updatedValues = {
      receiver: [`${user_email}`],
      agreement_id: contract && contract.id,
      remark: "Sent to self",
      company_id: localStorage.getItem("companyId") || comp_id
    };
    axiosInstance.post(`/contract/send-agreement-to-self/`, updatedValues)
      .then((response) => {
        message.success(response.data.message);
        setIsThirdPartyVisible(false);
        fetchContracts();
        navigate("/admin/contracts/");
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setIsSendModalVisible(false);
      });
  };
  const fetchCompanyUsers = async () => {
    try {
      const response = await axiosInstance.post(`/user/get_user_email/`, {
        company_id: compnayId,
        is_active: true,

      })
      const existIds = contract.contract_access_users.map((item) => item.id)
      const newOptions = response.data.data.filter((item) => !existIds.includes(item.id)).map((item) => ({
        value: item.email, // Set the value to the email property
        label: `${item.first_name} (${item.role})`, // Set the label to a relevant property from your API data
      }));
      const newOptionsWithID = response.data.data.map((item) => ({
        value: item.id,
        label: `${item.first_name} ${item.role}`,
      }));
      setCompanyDiffUsers(newOptionsWithID);
    } catch (error) { }
  };
  const fetchAgreementPdf = async (params) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get_agreement_summary/`, {
        customParams: {
          agreement_id: params
        }
      })
      if (response) {
        setIsLoading(false);
        handlePdfDownload(response.data.data && response.data.data);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleEsignButton = async () => {
    setIsLoading(true);
    if (contract.agreement_file) {
      try {
        const response = await axiosInstance.post(`/esign/add_document/`, {
          agreement_id: contract.id,
          status: "UNDER_EXECUTION",
          remarks: "Send to Esign",
          agreement_file_edit_permission_user_id: contract.editable_user,
        });
        if (response?.data) {
          window.open(response.data.redirect_url, "_blank", "noreferrer");
          navigate("/admin/contracts");
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        // message.error(error.response);
      }
    }
  };
  const handleEmailChange = (value) => {
    // Handle the changes in email addresses
    console.log(value);
  };
  const isStatusExcuted = () => {
    return contract?.status === "EXECUTED" || contract?.status === "TRANSACTION_CLOSED";
  }

  console.log(isStatusExcuted(), !isStatusExcuted(), "status excuted or not")
  const content = (
    <>
      <div className="flex flex-col">
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full hidden"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('sendOrganization', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleSendButton()
              }}
              icon={<MailOutlined />}
            >
              Send within organization
            </Button>
          </>
        ) : null}
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full hidden"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                }
                const isEsignStatus = isEsignPenCom('counterParty', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleThirdPartyButton()
              }}
              icon={<SendOutlined />}
            >
              Send Agreement
            </Button>
          </>
        ) : null}
        {role &&
          contract &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
              onClick={() => {

                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                }
                const isEsignStatus = isEsignPenCom('sendSelf', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleSubmitSendToSelf()
              }}
              icon={<SendOutlined />}
            >
              Send to Self
            </Button>
          </>
        ) : null}
        {/* {role && contract?.agreement_file && contract.status !== "FRESH_REQUEST" && contract.status !== "UNDER_NEGOTIATION" ? ( */}
        {role && contract?.agreement_file &&
          contract.editable_user &&
          !isStatusExcuted() &&
          parseInt(user_id) ===
          parseInt(contract.editable_user) ? (
          <>
            <Button
              className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?",
                  'completed': "The Agreement has been signed by all the Parties. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('Esign', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleEsignButton()
              }}
              icon={<FileTextOutlined />}
            >
              E-sign
            </Button>
          </>
        ) : null}
        {role && contract && contract.editable_user && parseInt(user_id) === parseInt(contract.editable_user) && !isStatusExcuted() ? (
          <>
            <Button
              className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
              onClick={() => {
                const param = {
                  'pending': "The Agreement has been forwarded for e-signature. Would you like to continue?"
                }
                const isEsignStatus = isEsignPenCom('otherUser', param)
                if (isEsignStatus) {
                  setModifyOpen(isEsignStatus);

                  return isEsignStatus;
                } // Open confirmation modal

                handleDiffUserButton()
              }}
              icon={<IdcardOutlined />}
            >
              Assign to Other User
            </Button>
          </>
        ) : null}
        <Button
          className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
          onClick={() => onEllipseDownload(contract.agreement_file, contract.document_id)}
          icon={<DownloadOutlined />}
        >
          Download Document
        </Button>
        {isStatusExcuted() ? (
          ""
        ) : (
          <>
            {contract &&
              parseInt(user_id) ===
              parseInt(contract.editable_user) ? (
              <Button
                className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
                onClick={() => {
                  setAgreementFileBeforeEsign(contract?.agreement_file_before_esign ?? null)
                  const agreementFile = contract?.agreement_file ?? null;
                  const param = {
                    'pending': "The Agreement has been forwarded for e-signature. Would you like to continue? ",
                    'completed': "The Agreement has been signed by all the Parties. Would you like to continue?"
                  }
                  const isEsignStatus = isEsignPenCom('modifyDoc', param)
                  if (isEsignStatus) {
                    setModifyOpen(isEsignStatus);

                    return isEsignStatus;
                  } else if (agreementFile) {
                    // If agreement file is available, open directly
                    openInNewTab(contract.id, agreementFile, agreementFileBeforeEsign);
                  } else {
                    message.info('You do not have agreement .')
                    console.error("No agreement file available to open.");
                  }
                }}
                icon={<HighlightOutlined />}
              >
                Modify Document
              </Button>


            ) : (
              ""
            )}
          </>
        )}

        {(role &&
          contract &&
          role === "admin" &&
          contract.status === "EXECUTED" &&
          contract.is_created_from_bulk_upload &&
          !contract.is_agreement_file_uploaded) ||
          (role &&
            contract &&
            contract.editable_user &&
            !isStatusExcuted() &&
            parseInt(user_id) ===
            parseInt(contract.editable_user)) ? (
          <>
            {role && (role === "agreement controller head" || role === "agreement controller team" || role === "professional agreement controller head" || role === "professional agreement controller team" || role === "professional") ? (
              <>
                <Popover
                  content={uploadContent}
                  title=""
                  trigger="hover"
                  placement="bottom"
                >
                  <Button>Upload</Button>
                </Popover>
              </>
            ) : (
              <div className="flex justify-center">
                <Upload
                  customRequest={customRequest}
                  showUploadList={false} // Hide the default file list
                >
                  <Button
                    icon={<UploadOutlined />}
                    loading={fileUploading}
                    className="border-transparent hover:!border-transparent hover:!text-[#4E36A3] w-full"
                  >
                    {fileUploading ? "Uploading" : "Upload Document"}
                  </Button>
                </Upload>
              </div>
            )}
          </>
        ) : null}
        <div className="flex justify-center"></div>
      </div>
    </>
  );
  const handleNext = () => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      Promise.all([
        SendContractForm.validateFields(),
        CounterPartyForm.validateFields(),
        differentUserForm.validateFields(),
        customFieldsForm.validateFields(),
        addUserForm.validateFields(),
        addAttachmentsForm.validateFields()
      ]).then(() => {
        const nextTab = (parseInt(activeTab, 10) % finalPage) + 1;
        const nextTabStr = nextTab.toString();
        setActiveTab(nextTabStr);

        const newParams = new URLSearchParams(location.search);
        newParams.set("tab", nextTabStr);
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
      });
    }
  };
  const handlePrevious = () => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      const previousTab = ((parseInt(activeTab, 10) - 2 + finalPage) % finalPage) + 1;
      const previousTabStr = previousTab.toString();
      setActiveTab(previousTabStr);

      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", previousTabStr);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  };

  const handleTabChange = (key) => {
    if (editMode || productEditMode) {
      if (canShowErrorMessage) {
        message.error("Please save/cancel form first.");
        canShowErrorMessage = false;
        setTimeout(() => {
          canShowErrorMessage = true;
        }, 2000);
      }
      setActiveTab(activeTab);
    } else {
      setActiveTab(key);

      // Update the URL to persist tab selection
      const newParams = new URLSearchParams(location.search);
      newParams.set("tab", key);
      navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    }
  };

  // const getAttachments = async () => {
  //   try {
  //     const response = await axiosInstance.get(`/contract/attachment/`, {
  //       customParams: {
  //         agreement_id: params.pk,
  //         company_id: compnayId
  //       }
  //     })
  //     if (response) {
  //       setAttachments(response.data);
  //     }
  //   } catch (error) {
  //     console.error(error)
  //   }
  // };
  // const handleAttachemntClick = () => {
  //   setAttachmentModal(true);
  // };
  // const handleAddForm = () => {
  //   if (formFields.length < 5) {
  //     const newForm = { id: formFields.length + 1, value: "" };
  //     setFormFields([...formFields, newForm]);
  //   } else {
  //     // Optionally, you can provide feedback to the user that they can't add more forms
  //     message.error("You can only add upto 5 fields.");
  //   }
  // };
  // const handleRemoveForm = (id) => {
  //   if (formFields.length > 1) {
  //     const updatedFormFields = formFields.filter((field) => field.id !== id);
  //     setFormFields(updatedFormFields);
  //   }
  // };
  // const handleAttachmentSave = async () => {
  //   setUploading(true);
  //   await addAttachmentsForm.validateFields();
  //   const values = await addAttachmentsForm.getFieldsValue();
  //   // You can perform further actions with the saved attachment here
  //   const payload = {
  //     ...values,
  //     agreement_id: contract && contract.id,
  //     attachment: fileName && fileName,
  //     company_id: compnayId
  //   };
  //   const formData = convertIntoFormData(payload);

  //   axiosInstance.post(`/contract/attachment/`, formData).then((response) => {
  //     message.success("Document Saved Successfully.");
  //     setFormFields([{ id: 1, value: "" }]);
  //     fetchContracts();
  //     getAttachments(contract && contract.id);
  //     setAttachmentModal(false);
  //     setUploading(false);
  //     addAttachmentsForm.resetFields();
  //     setFilename();
  //   })
  //     .catch((error) => {
  //       message.error(error.response.data.error);
  //       setFormFields([{ id: 1, value: "" }]);
  //       setAttachmentModal(false);
  //       setUploading(false);
  //       addAttachmentsForm.resetFields();
  //       setFilename();
  //     });
  // };
  // const handleCustomFieldSave = async () => {
  //   try {
  //     await customFieldsForm.validateFields();
  //     const data = customFields.reduce((acc, item, index) => {
  //       const fieldIndex = index + findMaxIndex(contract && contract.custom_field);
  //       return acc = { ...acc, [`field${fieldIndex + 1}`]: item?.field, [`value${fieldIndex + 1}`]: item?.value }
  //     }, {})
  //     let payload = {};
  //     payload = { ...contract.custom_field, ...data };
  //     if (!Object.values(data).length) {
  //       throw new Error("Add at least one custom field");
  //     }
  //     handleSave({ custom_field: payload });
  //   } catch (error) {
  //     message.error(error.message || 'Form is invalid!');
  //   }
  // };

  const fetchClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/clause/?company_id=${compnayId}`);
      setIsLoading(false);
      setClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const fetchMasterClause = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-clause/`);
      setIsLoading(false);
      setMasterClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleSequenceChange = (id, sequence) => {
    setClausesData(
      clausesData.map((item) => {
        if (item.id === id) {
          return { ...item, sequence };
        }
        return item;
      })
    );
  };
  const handleEsignStatus = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post(`/esign/get_document_status/`, { agreement_id: contract.id })
      if (response && response?.data) {
        const tempResponse = response?.data;
        const recipients = () => {
          const tempArr = tempResponse.recepients.map((recipient) => {
            return {
              fullName: recipient.FullName,
              email: recipient.EmailAddress,
              signatureImage: recipient.SignatureUpload,
              status: recipient.StatusCode,
            };
          });
          return tempArr;
        };

        setSignuluResponse({
          recepients: recipients(),
          addComments: tempResponse.addComments,
          senderName: tempResponse.senderName,
          statusCode: tempResponse.statusCode,
          expirationDate: tempResponse.expirationDate,
          fileName: tempResponse.uploadDocuments[0]?.FileName,
        });
        setEsignDetailModalOpen(true);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      message.error(error?.response?.data?.error);
    }
  };
  const handleEsignDocDownload = async () => {
    setIsLoading(true);
    try {
      // 1️⃣ Get the file URL from the API
      const response = await axiosInstance.post(`/esign/download_document/`, { agreement_id: contract.id });
      const fileUrl = response?.data?.document_url;

      if (!fileUrl) throw new Error("No document URL returned");

      // 2️⃣ Fetch the actual file using the returned URL
      const fileResponse = await fetch(fileUrl);
      if (!fileResponse.ok) {
        throw new Error(`Failed to download file. Status: ${fileResponse.status}`);
      }

      // 3️⃣ Create a blob from the response
      const blob = await fileResponse.blob();
      const objectURL = URL.createObjectURL(blob);

      // 4️⃣ Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = objectURL;
      link.download = 'e-sign-document.pdf';
      document.body.appendChild(link);
      link.click();

      // 5️⃣ Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(objectURL);
      fetchContracts();
      message.success("File downloaded successfully.");
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.error || "Error in downloading");
    } finally {
      setIsLoading(false);
    }
  };
  // let customDFieldsCount = 0;
  // if (contract && contract.custom_field) {
  //   customDFieldsCount = contract && Object.keys(contract.custom_field).length; // Get the number of keys in custom_field
  // }
  if (fileUploading) {
    message.loading("File Uploading from Device ...", 0)
  }
  // if (isClauseLoading) {
  //   message.loading("File Uploading from Clause ...", 0)
  // }
  // if (isMasterLoading) {
  //   message.loading("File Uploading from Master Templete...", 0)
  // }


  useEffect(() => {
    if (signuluResponse?.recepients) {
      console.log(signuluResponse?.recepients)
      const emailsToRemind = signuluResponse.recepients
        .filter(r => r.status?.toUpperCase() === "SENT")
        .map(r => r.email);
      console.log(emailsToRemind, "emailsToRemind")
      setPendingEmails(emailsToRemind);
    }
  }, [signuluResponse]);

  useEffect(() => {
    if (clauseTempModal) {
      fetchMasterClause();
      fetchClauses();
    }
  }, [clauseTempModal]);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // User came back to the tab
        fetchContracts(); // Refresh the document details
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  // useEffect(() => {

  //   if (contract && contract.id) {
  //     getAttachments(contract && contract.id);
  //   }
  // }, [contract]);
  useEffect(() => {
    if (tab === 'versionControl') {
      setActiveTab("3");
    }
  }, [tab])
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get(`/country/get/`)
        setCountries(response.data); // Update the state with the fetched user data
      } catch (error) {
        console.error(error)
      }
    };
    fetchCountry();
  }, []);
  useEffect(() => {
    fetchContracts();
  }, [contract?.id]);
  useEffect(() => {
    if (
      contract &&
      contract.client_address &&
      contract.client_address.country &&
      contract.client_address.country.id
    ) {
      fetchState(contract.client_address.country.id, "client");
    }
    if (
      contract &&
      contract.party_address &&
      contract.party_address.country &&
      contract.party_address.country.id
    ) {
      fetchState(contract.party_address.country.id, "party");
    }
  }, [contract]);
  useEffect(() => {
    fetchCompanyUsers();
  }, [contract]);
  useEffect(() => {
    if (!fileUploading && !isClauseLoading && !isMasterLoading) {
      fetchContracts();
    }
  }, [fileUploading, isClauseLoading, isMasterLoading]);
  useEffect(() => {
    fetchMasterTemplates();
    // fetchTemplates();
  }, []);

  useEffect(() => {
    if (params.pk) {
      fetchContracts(params.pk); // ✅ API call here
    }
  }, [params.pk]);

  // const attchmentsColumns = [
  //   {
  //     title: "Sender",
  //     dataIndex: "sender_name",
  //     render: (_, record) => record.third_party_sender_name || record.sender_name
  //   },
  //   {
  //     title: "Stage",
  //     dataIndex: "agreement_stage",
  //     render: (text) => capitalizeAndRemoveUnderscores(text),
  //   },
  //   {
  //     title: "Brief particulatrs",
  //     dataIndex: "brief_particulars",
  //   },
  //   {
  //     title: "Download Document",
  //     dataIndex: "attachment",
  //     render: (_, record) => (
  //       <Space>
  //         <Button
  //           type="primary"
  //           onClick={() => handlePdfDownload(record.attachment)}
  //         >
  //           <DownloadOutlined />
  //         </Button>
  //       </Space>
  //     ),
  //   },
  // ];

  useEffect(() => {
    console.log("Compare Mode:", compareMode);
  }, [compareMode]);

  if (errorinContractGet) {
    return (
      <div className="flex justify-center items-center h-[70%]">

        <Result
          status="403"
          title="Failed to fetch contract details"
          subTitle={errorinContractGet || "Agreement not found. Please try again later."}
          extra={<Button type="primary" onClick={() => navigate(-1)}>Go Back</Button>}
        />
      </div>
    );
  }

  const handleConfirmModify = () => {
    const currentUserId = parseInt(user_id);
    const editableUser = parseInt(contract?.editable_user);

    if (warMdlType.current === 'sendOrganization') {
      handleSendButton();
    } else if (warMdlType.current === 'counterParty') {
      handleThirdPartyButton();
    } else if (warMdlType.current === 'sendSelf') {
      handleSubmitSendToSelf();
    } else if (warMdlType.current === 'Esign') {
      handleEsignButton();
    } else if (warMdlType.current === 'otherUser') {
      handleDiffUserButton();
    } else if (warMdlType.current === 'modifyDoc') {
      if (currentUserId === editableUser) {
        openInNewTab(
          contract?.id,
          contract?.agreement_file,
          contract?.agreement_file_before_esign
        );
      } else {
        console.error('Modification not allowed for this user.');
      }
    } else if (warMdlType.current === 'uploadFromLocal') {
      uploadRef.current.upload.uploader.onClick();
    } else if (warMdlType.current === 'uploadFromClause') {
      handleClauseTempButton();
    } else if (warMdlType.current === 'uploadFromMstTem') {
      handleMasterTempButton();
    }
    setModifyOpen(false);
  };


  return (
    <>

      {/* <Modal
        title="Linked Agreements"
        open={isLinkedModalVisible}
        footer={null}
        onCancel={() => setIsLinkedModalVisible(false)}
      >
        {contract?.linked_expired_agreements?.map((item) => (
          <div
            key={item.linked_agreement_id}
            className="cursor-pointer mb-2 flex justify-between items-center my-5"
            onClick={() => {
              setIsLinkedModalVisible(false);
              navigate(`/admin/contracts/${item.linked_agreement_id}`);
            }}
          >
            <div>

              {item.linked_document_id}
            </div>
            <ExportOutlined
              className="text-blue-600 cursor-pointer"
              onClick={() => {
                setIsLinkedModalVisible(false);
                navigate(`/admin/contracts/${item.linked_agreement_id}`);
              }}
            />
          </div>
        ))}
      </Modal> */}
      <FutureDateWarningModal
        visible={dateModalVisible}
        onClose={() => setDateModalVisible(false)}
      />

      <LinkedAgreementsModal
        visible={isLinkedModalVisible}
        onClose={() => setIsLinkedModalVisible(false)}
        linkedAgreements={contract?.linked_expired_agreements}
      />

      <SendContractModal
        visible={isSendModalVisible}
        onOk={handleOk}
        onCancel={handleModalCancel}
        form={SendContractForm}
        statusOptions={statusOptions}
        selectedStatus={selectedStatus}
        selectedStatusOption={selectedStatusOption}
        contractUsersOption={contractUsersOption}
      />

      <CounterPartyModal
        visible={isThirdPartyVisible}
        onOk={handleOk}
        onCancel={handleModalCancel}
        form={CounterPartyForm}
        handleEmailChange={handleEmailChange}
      />

      <ConfirmModifyModal
        visible={isModifyOpen}
        onOk={handleConfirmModify}
        onCancel={() => setModifyOpen(false)}
        content={warMdlBod.current}
      />

      <AssignDiffUserModal
        visible={isDifferentUser}
        onOk={handleOk}
        onCancel={handleModalCancel}
        form={differentUserForm}
        companyDiffUsers={companyDiffUsers}
      />

      <PreviewModal
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        previewFile={previewFile}
        darkMode={darkMode} // agar darkMode available hai
        id={contract?.id}
      />
      {/* <Modal
                title="Assign Contract to Different User"
                open={isDifferentUser}
                onOk={() => { handleOk('Contract to Different User') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={differentUserForm} initialValues={{ user_id: null }} onFinish={assignDiffUser}>
                  <Form.Item
                    name="user_id"
                    className="pt-1"
                    rules={[{ required: true, message: "Please select a user!" }]}
                  >
                    <Select
                      value={differentUserForm.getFieldValue("user_id")} // Ensure correct value binding
                      options={companyDiffUsers
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((user) => ({
                          value: user?.value,
                          label: `${user.label}`,
                        }))}
                      onChange={(value) => differentUserForm.setFieldsValue({ user_id: value })} // Update on change
                    />
                  </Form.Item>
                </Form>

              </Modal> */}
      <SentAgreementModel isOpen={isOpnSentAgreement} onClose={() => { setIsOpnSentAgreement(false) }} agreement_id={contract?.id} />

      <MasterTemplateModal
        visible={masterTempModal}
        onCancel={handleMasterTempCancelButton}
        onSelect={uploadMasterTemp}
        data={templateData}
        masterTempData={masterTemplateData}
        okText="Upload"
        loading={masterTempUploading}
      />
      <ClausesModal
        visible={clauseTempModal}
        onCancel={handleClauseTempCancelButton}
        clausesData={clausesData}
        masterClausesData={masterClausesData}
        handleSequenceChange={handleSequenceChange}
        onSubmit={handleClauseSubmit}
        // directSubmit={true}
        loading={isLoading}
      />

      {contract ? (
        <>
          <div className="flex flex-row justify-between items-center h-full p-[-10px]">
            <div className="flex items-center text-[15px] gap-4 font-semibold dark:text-white">
              <ArrowLeftOutlined className="text-xl transform hover:scale-110 transition-transform duration-300" onClick={() => {
                location.state ? navigate(pathname, { state: location.state }) : navigate(-1);
              }} />  Agreement Details
            </div>
            <div >
              {!editMode && (
                <Popover
                  placement="left"
                  title={""}
                  content={content}
                  // trigger="click"
                  className="h-[3rem]"
                >
                  <Button>
                    <MoreOutlined />
                  </Button>
                </Popover>
              )}
              {/* <Modal
                title="Send Contract"
                open={isSendModalVisible}
                onOk={() => { handleOk('Send Contract') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={SendContractForm} onFinish={handleSendSubmit}>
                  <h1 className="font-lg">Please select the status</h1>
                  <Form.Item name="status" className="pt-1">
                    <Select
                      options={statusOptions}
                      onChange={selectedStatusOption}
                    ></Select>
                  </Form.Item>

                  {selectedStatus &&
                    (selectedStatus === "EXECUTED" ||
                      selectedStatus === "TRANSACTION_CLOSED") ? (
                    ""
                  ) : (
                    <>
                      <h1 className="font-lg">Edit Right</h1>
                      <Form.Item
                        name="agreement_file_edit_permission_user_id"
                        className="pt-1"
                      >
                        <Select
                          options={contractUsersOption && contractUsersOption}
                        ></Select>
                      </Form.Item>
                    </>
                  )}

                  <h1 className="font-lg">Remark</h1>
                  <Form.Item
                    name="remarks"
                    className="pt-1"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a value.",
                      },
                    ]}
                  >
                    <TextArea />
                  </Form.Item>
                </Form>
              </Modal> */}
              {/* <Modal
                title="Send Contract to Counter Party"
                open={isThirdPartyVisible}
                onOk={() => { handleOk('Counter Party') }}
                onCancel={handleModalCancel}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Send"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Ok button
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }} // Set background color for the Cancel button
              >
                <Form form={CounterPartyForm} onFinish={handleThirdPartySubmit}>
                  <h1 className="font-lg">Receiver's Email</h1>
                  <Form.Item name="receiver" className="pt-1">
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Enter receiver's email"
                      onChange={handleEmailChange}
                      required
                    ></Select>
                  </Form.Item>
                  <h1 className="font-lg">Remark</h1>

                  <Form.Item name="remark" className="pt-1">
                    <TextArea required />
                  </Form.Item>
                </Form>
              </Modal> */}
              {/* <Modal
                title="Are you sure?"
                open={isModifyOpen}
                onOk={() => {
                  // Ensure only valid users can modify
                  const currentUserId = parseInt(user_id);
                  const editableUser = parseInt(contract?.editable_user);

                  if (warMdlType.current === 'sendOrganization') {
                    handleSendButton()
                  } else if (warMdlType.current === 'counterParty') {
                    handleThirdPartyButton()
                  } else if (warMdlType.current === 'sendSelf') {
                    handleSubmitSendToSelf()
                  } else if (warMdlType.current === 'Esign') {
                    handleEsignButton()
                  } else if (warMdlType.current === 'otherUser') {
                    handleDiffUserButton()
                  } else if (warMdlType.current === 'modifyDoc') {

                    if (currentUserId === editableUser) {
                      openInNewTab(
                        contract?.id,
                        contract?.agreement_file, contract?.agreement_file_before_esign
                      );
                    } else {
                      console.error("Modification not allowed for this user.");
                    }

                  } else if (warMdlType.current === 'uploadFromLocal') {
                    uploadRef.current.upload.uploader.onClick();
                  } else if (warMdlType.current === 'uploadFromClause') {
                    handleClauseTempButton();
                  } else if (warMdlType.current === 'uploadFromMstTem') {
                    handleMasterTempButton();
                  }
                  setModifyOpen(false);
                }}
                onCancel={() => setModifyOpen(false)}
                style={{ fontSize: "24px", padding: "40px" }}
                okText="Yes"
                okButtonProps={{
                  style: {
                    backgroundColor: "#4E36A3",
                    color: "white",
                    height: "40px",
                    width: "100px",
                  },
                }}
                cancelButtonProps={{
                  style: {
                    backgroundColor: "",
                    color: "#4E36A3",
                    height: "40px",
                    width: "100px",
                  },
                }}
              >
                <h1>
                  {warMdlBod.current}
                </h1>
              </Modal> */}

            </div>
          </div>
          <div style={{ height: '100%', minHeight: '600px', overflow: 'auto' }}>
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 10,
                  backgroundColor: 'rgba(255,255,255,0.6)',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Spin tip="Loading..." size="large" />
              </div>
            )}
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              type="card"
              size="small"
              animated={false}
              destroyInactiveTabPane={false}
              tabBarStyle={{ marginBottom: 0 }}
              style={{ flex: 1 }}
            >
              <TabPane forceRender tab="Business Detail" key="1">
                <BussinessDetailsComponent
                  contract={contract}
                  editedContract={editedContract}
                  editMode={editMode}
                  handleEdit={handleEdit}
                  handleCancel={handleCancel}
                  handleSave={handleSave}
                  newData={newData}
                  setEditedContract={setEditedContract}
                  handleAddressChange={handleAddressChange}
                  fetchState={fetchState}
                  clientStates={clientStates}
                  partyStates={partyStates}
                  handleAgreementChange={handleAgreementChange}
                  years={years}
                  setYears={setYears}
                  months={months}
                  setMonths={setMonths}
                  days={days}
                  setDays={setDays}
                  setExecutionDate={setExecutionDate}
                  setDateModalVisible={setDateModalVisible}
                  setEffectiveDate={setEffectiveDate}
                  setIsLinkedModalVisible={setIsLinkedModalVisible}
                  handleOpenLinkedModal={handleOpenLinkedModal}
                  fetchAgreementPdf={fetchAgreementPdf}
                  isLoading={isLoading}
                />
              </TabPane>
              <TabPane forceRender tab="Products / Services" key="2">
                <EditProductsTab created_by={contract.created_by} status={contract.status} editable_user={contract.editable_user} is_draft={contract.is_draft} allPduData={contract.product_list} handleSave={handleSave} />
              </TabPane>
              <TabPane forceRender tab="Version Control" key="3">
                {/* <div className=" text-black py-3 px-2 h-[60px] flex items-center justify-between">
                  <h1 className="font-semibold text-[15px] dark:text-white">
                    Version Control
                  </h1>
                  <div className="flex items-center justify-end gap-3">
                    {contract && contract?.contract_history.length > 0 && <div className="gap-2 items-center flex flex-col justify-center">
                      <div>
                        <Button
                          type={"default"
                          }
                          danger={compareMode && (!selectedPrev || !selectedCurr)}
                          loading={isComparing} // 🔥 new state for comparing feedback
                          className={`rounded-[10px] border text-purple mt-5 border-[#d8bfd8] transition-colors duration-300 ${compareMode ? "h-[30px]" : "h-[47.2px]"
                            }`}
                          onClick={async () => {
                            // 🔹 Case 1: Enable compare mode
                            if (!compareMode) {
                              setCompareMode(true);
                              setSelectedPrev(null);
                              setSelectedCurr(null);
                              message.info("Compare Mode Enabled. Select two DOCX files to compare.");
                              return;
                            }

                            // 🔹 Case 2: Disable compare mode (no files selected)
                            if (compareMode && (!selectedPrev || !selectedCurr)) {
                              setCompareMode(false);
                              setSelectedPrev(null);
                              setSelectedCurr(null);
                              message.info("Compare Mode Disabled.");
                              return;
                            }

                            // 🔹 Case 3: Both selected → Compare Now
                            if (compareMode && selectedPrev && selectedCurr) {
                              setIsComparing(true);
                              message.loading({
                                content: "Files are comparing...",
                                key: "compareStatus",
                                duration: 0,
                              });

                              try {
                                await handleChangeView(selectedPrev, selectedCurr); // your API or function
                                message.success({
                                  content: "Comparison complete!",
                                  key: "compareStatus",
                                });
                              } catch (err) {
                                message.error({
                                  content: "Error comparing files!",
                                  key: "compareStatus",
                                });
                              } finally {
                                setIsComparing(false);
                                setCompareMode(false);
                                setSelectedPrev(null);
                                setSelectedCurr(null);
                              }
                            }
                          }}
                        >
                          {compareMode
                            ? selectedPrev && selectedCurr
                              ? "Compare Now"
                              : "Disable Compare Mode"
                            : "Enable Compare Mode"}
                        </Button>
                      </div>
                      <div>
                        {compareMode && (
                          <div style={{ marginBottom: 10 }}>
                            <Tag color="blue" size="small">
                              {selectedCurr ? "✅ Curr File" : "🟠 Select Curr File"}
                            </Tag>
                            <Tag color="blue" size="small">
                              {selectedPrev ? "✅ Prev File" : "🟠 Select Prev File"}
                            </Tag>
                          </div>
                        )}
                      </div>
                    </div>}
                    {contract.esign_status !== "draft" && (
                      <Button
                        onClick={handleEsignStatus}
                        type="submit"
                        className={`h-12 w-[15rem]  rounded-[10px] border border-[#d8bfd8] transition-colors duration-300 mt-8 -mr-2 mb-10 !text-purple !hover:text-[#800080] !bg-white`}
                      >
                        View E-sign Status
                      </Button>
                    )}
                  </div>

                </div>

                <Modal
                  title="E-sign Status"
                  centered
                  open={esignDetailModalOpen}
                  closable={false}
                  maskClosable
                  width={1000}
                  footer={
                    [
                      <Button
                        key="reminder"
                        type="primary"
                        loading={isReminderLoading}
                        onClick={handleSendReminder}
                        disabled={!pendingEmails || pendingEmails.length === 0}
                      >
                        Send Reminder
                      </Button>,
                      <Button
                        key="close"
                        type="default"
                        onClick={() => setEsignDetailModalOpen(false)}
                      >
                        Close
                      </Button>,
                    ]
                  }
                >
                  <>
                    <div className="text-sm font-semibold my-2">
                      Signature Initiated By-
                      <span className="font-medium mx-2">
                        {signuluResponse.senderName}
                      </span>
                    </div>
                    <div className="text-sm font-semibold my-2">
                      Comments
                      <span className="font-medium mx-2">
                        {signuluResponse.addComments
                          ? signuluResponse?.addComments.map(
                            (comment, index) => {
                              return (
                                <span key={index}>
                                  {index !== signuluResponse.length() - 1
                                    ? `${comment},`
                                    : `${comment}`}
                                </span>
                              );
                            }
                          )
                          : "No Comments"}
                      </span>
                    </div>
                    <div className="text-sm font-semibold my-2">
                      Expiration Date-
                      <span className="font-medium mx-2">
                        {signuluResponse?.expirationDate}
                      </span>
                    </div>
                    <div className="text-sm font-semibold my-2">
                      E-sign Status-
                      <span className="font-semibold mx-2 mt-4">
                        {signuluResponse?.statusCode?.toLowerCase() ===
                          "approved" ? (
                          <span className="bg-[#479D491A] text-[#479D49] px-2 py-2">
                            {signuluResponse.statusCode}
                          </span>
                        ) : signuluResponse?.statusCode?.toLowerCase() ===
                          "rejected" ? (
                          <span className="text-[#BA3928] bg-[#BA39281A] px-2 py-2">
                            {signuluResponse.statusCode}
                          </span>
                        ) : (
                          <span className="text-[#F7CB73] bg-[#F7CB731A] px-2 py-2 ">
                            {signuluResponse.statusCode}
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="">
                      <div className="text-sm font-semibold flex justify-between items-center h-10">
                        <span>Recipients Details</span>
                        {signuluResponse?.statusCode?.toLowerCase() !==
                          "pending" && (
                            <Button
                              // isLoading
                              loading={isLoading} // Show loading spinner
                              disabled={isLoading}
                              onClick={handleEsignDocDownload}
                              type="submit"
                              className="flex items-center rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10 my-0"
                            >
                              Download Signed Document
                            </Button>
                          )}
                      </div>
                      <Table
                        dataSource={signuluResponse?.recepients}
                        columns={esignColumns}
                        pagination={false}
                        scroll={{ x: "max-content" }}
                        bordered
                        className="mb-4 text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
                      />
                    </div>
                  </>
                </Modal>
                <Table
                  dataSource={
                    contract?.contract_history?.map((item, index) => ({
                      ...item,
                      key: item.id || item._id || index,
                    }))
                  }
                  columns={columns}
                  pagination={false}
                  scroll={{ x: "max-content" }}
                  bordered
                  size="small"
                  className="mt-1
                      [&_.ant-table-cell]:!p-[3px] 
                      [&_.ant-table-cell]:!text-[11px] 
                      [&_.ant-table-thead_.ant-table-cell]:!text-[12px] 
                      [&_.ant-table-thead_.ant-table-cell]:!p-[4px]"
                /> */}
                <VersionControl
                  contract={contract}

                  // Compare mode props
                  compareMode={compareMode}
                  setCompareMode={setCompareMode}
                  selectedPrev={selectedPrev}
                  setSelectedPrev={setSelectedPrev}
                  selectedCurr={selectedCurr}
                  setSelectedCurr={setSelectedCurr}
                  isComparing={isComparing}
                  setIsComparing={setIsComparing}
                  handleChangeView={handleChangeView}

                  // E-sign props
                  handleEsignStatus={handleEsignStatus}
                  esignDetailModalOpen={esignDetailModalOpen}
                  setEsignDetailModalOpen={setEsignDetailModalOpen}
                  signuluResponse={signuluResponse}
                  handleSendReminder={handleSendReminder}
                  isReminderLoading={isReminderLoading}
                  handleEsignDocDownload={handleEsignDocDownload}
                  isLoading={isLoading}
                  esignColumns={esignColumns}
                  pendingEmails={pendingEmails}
                  columns={columns}
                />

              </TabPane>
              <TabPane forceRender tab="Custom Tab" key="4">
                <CustomTab
                  contract={contract}
                  editedContract={editedContract}
                  handleSave={handleSave}
                  handleCancel={handleCancel}
                />
              </TabPane>
              <TabPane forceRender tab="Approval Matrix" key="5">
                <ApprovalMatrixTimeline2 contract={contract} />
              </TabPane>
              <TabPane forceRender tab="Email Records" key="6">
                <EmailSystem contract={contract} fetchContracts={fetchContracts} isEsignPenCom={isEsignPenCom} />
              </TabPane>
            </Tabs>
          </div>
          <div className=" justify-start items-center mt-4 relative bottom-0 left-0 flex pt-[30px]" >
            {activeTab !== "1" && (
              <ButtonComp
                text="Previous"
                textColor="#4E36A3"
                bgColor="white"
                onClick={handlePrevious}
                margin="2rem"
              />
            )}
            {parseInt(activeTab) !== parseInt(finalPage) ? (
              <>
                {editMode ? (
                  ""
                ) : (
                  <ButtonComp
                    text="Next"
                    bgColor="#4E36A3"
                    textColor="white"
                    onClick={handleNext}
                  />
                )}
              </>
            ) : (
              <>
                {editMode ? (
                  ""
                ) : (
                  <ButtonComp
                    text="Finish"
                    bgColor="#4E36A3"
                    textColor="white"
                    onClick={handleNext}
                  />
                )}
              </>
            )}
          </div>
        </>
      ) : (
        ""
      )}
      {contract?.id && <Chat id={contract?.id} fromNotification={fromNotification} />}
    </>
  );
}

export default ContractDetailComp;
